import * as React from 'react';
import { useState } from 'react';
import Modal from '../../components/modal';
import PersonForm from '../PersonForm';
import { Button, Text, View } from 'native-base';
import { renderAutoComplete as AutoComplete } from '../../forms/renderedComponents';
import { StyleSheet } from 'react-native';

//quick customer search (autocomplete text box)
//gives customer id back
export default function CustomerSelect({ setCust, customers, cancel }) {
	const [id, setId] = useState();
	const [newName, setNewName] = useState();

	const tryClose = () => {
		//console.log('close');
		if (id) return setCust(id);
	};

	const changedInput = id => {
		//console.log(id);
		//setId(id);
		setCust(id);
	};

	const closeNew = cid => {
		if (!cid) return;
		setNewName(null);
		setCust(cid);
	};

	return (
		<>
			{!!newName && <PersonForm closure={id => id && setCust(id)} personType={'customer'} name={newName} closure={closeNew} />}
			<View padder style={{ flex: 1, alignItems: 'center' }}>
				<AutoComplete
					icon="person"
					emptyText=" - Select or create customer - "
					data={customers}
					openAdder={setNewName}
					input={{ onChange: changedInput, value: id }}
					meta={{}}
					style={{ maxWidth: 500 }}
				/>
				<View style={{ width: '100%', maxWidth: 500, backgroundColor: '#DDD', flexDirection: 'row', justifyContent: 'flex-end' }}>
					<Button transparent onPress={tryClose}>
						<Text>OK</Text>
					</Button>
				</View>
			</View>
		</>
	);
}

const styles = StyleSheet.create({
	modalStyle: {
		borderRadius: 10,
		alignItems: 'center',
		justifyContent: 'center',
		width: '90%',
		height: '100%',
		backgroundColor: 'transparent'
	},
	modalContainer: {
		flex: 1,
		margin: 0,
		borderTopLeftRadius: 10,
		borderTopRightRadius: 10,
		//justifyContent: 'center',
		backgroundColor: '#f8f8fc'
	},
	innerContainer: {
		flex: 1,
		margin: 0
		//alignItems: 'center',
	},
	modalHeader: {
		height: 45,
		borderTopLeftRadius: 10,
		borderTopRightRadius: 10
	}
});

/*
Todo:
Make this work. invoiceFormContainer already has customer edit modal... do we include it here, too? Can pass it name and be confident we get id back
Add bank import
Invoice goods & services -- discounts
    due date?
Work on smaller font size on desktop

2-column dashboard?

*/
